export default {

	computed: {

		countSelected() {
			return this.selected.length
		},

		fieldDefs() {
			return this.infoData.fieldDefs
		},

		selectedIds() {
			return this.selected.map((element) => {
				return element.id
			})
		},

		getUsersLimit() {
			if(this.maxUsers && this.usersNumber)
				return this.usersNumber + ' / ' + this.maxUsers
		},

		actionPositionAbsolute() {
			if(this.actionPosition === 'absolute') {
				return true
			} else {
				return false
			}
		},

		actionPositionFixed() {
			if(this.actionPosition === 'fixed') {
				return true
			} else {
				return false
			}
		},		
	},

	watch: {
	    selected: {
	        handler() {
	            this.selected.length > 0 ? this.disabled = false : this.disabled = true
				this.$emit('update:selected', this.selected)
	        }
	    }
	},

	methods: {
		toggleAll () {
			if (this.selected.length) {
				this.selected = []   
			} else { 
				this.selected = this.items.slice()
			}
		},

		changeSort(header) {
			if(typeof header.sortable === 'undefined' || header.sortable){
				let column = header.value
				if (this.pagination.sortBy === column) {
					this.pagination.descending = !this.pagination.descending
				} else {
					this.pagination.sortBy = column
					this.pagination.descending = false
				}
			}
		},

		deleteModels() {
			let ids = this.selectedIds

			this.axios.post(this.modelDef + '/delete', {ids: ids}).then(response => {
				// get body data
				let data = response.data
				this.disabled = true
				this.selected = []
				// i totali di footer, dove previsti, vanno ricalcolati
				if(typeof this.invalidateTotals === 'function') {
					this.invalidateTotals()
				}
				this.getDataFromApi()
				this.confirmDelete = false
				let snackmessage = ''
				let snackcolor = ''
				if(data.status == 'message' || data.message){
					snackmessage = data.message
					snackcolor = 'warning'
				} else {
					snackmessage = 'Elementi eliminati con successo.'
					snackcolor = 'success'
				}
				this.$store.commit('setSnackbar', {timeout: 6000, text: snackmessage, value: true, color: snackcolor})

				// Emit event for document numbering gaps update
				this.$eventBusUtility.$emit('documentsDeleted', {
					modelDef: this.modelDef,
					ids: ids
				})

			}, response => {
				// error callback
			});
		},

		getChipText(header, chip) {
            let h = header.options.find((opt) => {
                    return opt.value === chip
                })
            if(h)
                return h.text
            else
                return chip
        },

        getCopy(item, action) {
            this.axios.get(action.getcopy_url + '/' + item.id).then(response => {

                let tempInput = document.createElement('input')
                tempInput.value = response.data.data
                document.body.appendChild(tempInput)
                tempInput.select()
                document.execCommand('copy')
                document.body.removeChild(tempInput)
                this.$store.commit('setSnackbar', {timeout: 6000, text: 'Copiato negli appunti!', value: true, color: 'success'})

            }, response => {
                // error callback
            })
        },

		checkDisabledAction(action, item) {
            if(action.depends_key != undefined) {
                return !item[action.depends_key]
            } else {
                return false
            }
        },
			
        goToLink(item, action) {
            let url = ''
            if(action.link_key) {
                url = item[action.link_key]
            } else if(action.link_url) {
                url = action.link_url
            } 
			if (!url.match(/^(https?:\/\/|#)/i)) {
				url = 'http://' + url;
			}
            window.open(url, '_blank')
        },		
	},
}